import { Page } from '@unistocks/components/page/page';
import { Anchor } from '@unistocks/components/text/link';
import { Heading } from '@unistocks/components/text/text';
import { useDevToolsEnabled } from '@unistocks/shared/hooks/use-feature';
import { t } from '@unistocks/shared/localization/index.ts';
import { Link } from 'expo-router';
import Head from 'expo-router/head';

export default function NotFoundScreen() {
  const isDevToolsEnabled = useDevToolsEnabled();

  return (
    <Page size="medium" justifyContent={'center'}>
      <Head>
        <title>{t('::DefaultErrorMessage404')}</title>
      </Head>
      <Page.Content gap={'$3'}>
        <Heading size={'$8'}>{"This page doesn't exist."}</Heading>

        <Link asChild href={'/'}>
          <Anchor size={'$6'}>{'Go to home screen'}</Anchor>
        </Link>

        {isDevToolsEnabled ? (
          <Link asChild href={'/_sitemap'}>
            <Anchor size={'$6'}>{'View sitemap'}</Anchor>
          </Link>
        ) : null}
      </Page.Content>
    </Page>
  );
}
